import { render, staticRenderFns } from "./GlossaryList.vue?vue&type=template&id=90a8b0c6&scoped=true&"
import script from "./GlossaryList.vue?vue&type=script&lang=js&"
export * from "./GlossaryList.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryList.vue?vue&type=style&index=0&id=90a8b0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a8b0c6",
  null
  
)

export default component.exports